/* eslint-disable no-console */

'use client';

const BYPASS_STORAGE_KEY = 'powerbet_bypass_coming_soon';
const BYPASS_COOKIE_NAME = 'powerbet_bypass_coming_soon';

/**
 * Sync bypass status from cookie to localStorage
 * This should be called on app initialization
 */
export function syncBypassStatus(): void {
  if (typeof window === 'undefined') return;

  try {
    // Get bypass status from cookie
    const cookies = document.cookie.split(';');
    const bypassCookie = cookies.find((cookie) => {
      return cookie.trim().startsWith(`${BYPASS_COOKIE_NAME}=`);
    });

    if (bypassCookie) {
      const bypassValue = bypassCookie.split('=')[1];
      if (bypassValue === 'true') {
        localStorage.setItem(BYPASS_STORAGE_KEY, 'true');
      } else {
        localStorage.removeItem(BYPASS_STORAGE_KEY);
      }
    } else {
      localStorage.removeItem(BYPASS_STORAGE_KEY);
    }
  } catch (error) {
    console.error('Error syncing bypass status:', error);
  }
}

/**
 * Clear bypass status from both localStorage and cookie
 * This should be called on logout
 */
export function clearBypassStatus(): void {
  if (typeof window === 'undefined') return;

  try {
    // Clear localStorage
    localStorage.removeItem(BYPASS_STORAGE_KEY);
    
    // Clear cookie
    document.cookie = `${BYPASS_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  } catch (error) {
    console.error('Error clearing bypass status:', error);
  }
}

/**
 * Check if bypass is currently active
 */
export function isBypassActive(): boolean {
  if (typeof window === 'undefined') return false;

  try {
    return localStorage.getItem(BYPASS_STORAGE_KEY) === 'true';
  } catch (error) {
    console.error('Error checking bypass status:', error);
    return false;
  }
}
